import React, { FunctionComponent, PropsWithChildren } from 'react';

import {
  default as MuiInputLabel,
  InputLabelProps,
} from '@mui/material/InputLabel';

const FormControl: FunctionComponent<InputLabelProps> = (
  props: PropsWithChildren<InputLabelProps>
) => {
  return <MuiInputLabel {...props}>{props.children}</MuiInputLabel>;
};

export default FormControl;
